
import React, { useState } from "react";
import "./ourservices.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faToolbox,
  faShippingFast,
  faBuilding,
  faHammer,
  faIndustry,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import img from "../../assets/banner-image/our-servicess.jpeg";
import img1 from "../../assets/ourservices/Project planning & scheduling.jpeg";
import img2 from "../../assets/ourservices/Budgeting & cost control.jpeg";
import img4 from "../../assets/ourservices/Labour and workforce management.jpeg";
import img3 from "../../assets/ourservices/Quality assurance and material management.jpeg";
import img5 from "../../assets/ourservices/Real-Time Monitoring & Reporting image .jpeg";
import img6 from "../../assets/ourservices/Disaster recovery and reconstruction.jpeg";
import img7 from "../../assets/ourservices/Commercial and industrial reconstruction.jpeg";
import img8 from "../../assets/ourservices/Residential reconstruction.jpeg";
import img9 from "../../assets/ourservices/Structural renovation and strengthening.jpeg";
import img10 from "../../assets/ourservices/Sustainable and green building pratices.jpeg";


import Topheader from "../topheader/Topheader";
import Navcivil from "../navbar/Navcivil";
import Footer from "../footer/Footer";

const Ourallservice = () => {
 
  const navItems = [
    { id: 1, title: "Project Planning & Scheduling", icon:  faArrowRight, image: img1, description: "Structured Project Roadmap – We develop a well-defined plan outlining all project phases, key milestones, and realistic timelines to ensure smooth execution.Efficient Resource Allocation – Our strategic approach optimizes workforce distribution and material management to enhance productivity and reduce delays.Proactive Risk Assessment & Mitigation – We identify potential challenges early and implement proactive solutions to minimize disruptions and ensure project success." },
    { id: 2, title: "Budgeting & Cost Control", icon: faArrowRight, image: img2, description: "Detailed Cost Estimation – Transparent pricing with accurate cost breakdowns.Expense Monitoring – Continuous tracking to avoid cost overruns.Value Engineering – Maximizing quality while optimizing budget." },
    { id: 3, title: "Quality Assurance & Materials Management", icon: faArrowRight, image: img3, description: "Use of High-Quality Materials – We procure top-grade materials for durability and longevity.On-Site Quality Checks – Regular inspections to ensure superior workmanship.Compliance with Safety & Building Codes – Adhering to legal and environmental standards." },
    { id: 4, title: "Labor & Workforce Management", icon: faArrowRight, image: img4, description: "Skilled Workforce Deployment – Efficient labor management for timely completion. Safety & Training Programs – Ensuring a safe working environment.Subcontractor Coordination – Managing vendors and subcontractors for smooth operations.Issue Resolution – Quick response to on-site challenges." },
    { id: 5, title: "Real-Time Monitoring & Reporting", icon: faArrowRight, image: img5, description: "Progress Tracking – Regular updates with milestone reviews.Client Reporting – Transparent communication on project status." },
    {id: 6, title:"Sustainable & Green Building Practices", icon: faArrowRight, image:img10,description:"Eco-Friendly Materials & Techniques – Using sustainable construction solutions.Energy-Efficient Designs – Reducing carbon footprint through smart construction.Waste Management Strategies – Minimizing construction waste for a cleaner environment."},
    {id: 7, title:"Structural Renovation & Strengthening", icon: faArrowRight, image:img9,description:"Foundation Reinforcement – Strengthening old foundations for better stability. Wall & Roof Repair – Rebuilding or enhancing damaged structures.Seismic Retrofitting – Making buildings earthquake-resistant."},
    {id: 8, title:"Residential Reconstruction", icon: faArrowRight, image:img8,description:" House Remodeling & Extensions – Expanding spaces while maintaining structural integrity.Heritage Home Restoration – Preserving traditional charm with modern upgrades.Complete Rebuilding – Tearing down and reconstructing homes with better design."},
    {id: 9, title:"Commercial & Industrial Reconstruction", icon: faArrowRight, image:img7,description:"Showroom & Retail Space Upgrades – Modernizing interiors and facades.Office Space Renovation – Reconstructing workspaces for improved efficiency. Factory & Warehouse Rehabilitation – Strengthening and optimizing industrial facilities. "},
    {id: 10, title:"Disaster Recovery & Reconstruction", icon: faArrowRight, image:img6,description:" Fire & Water Damage Repairs – Restoring homes and buildings to their original condition.Storm & Earthquake Damage Repairs – Strengthening structures against future disasters.Old Building Restoration – Reviving aged buildings with modern safety standards."},
  ];

 
  const [selectedItem, setSelectedItem] = useState(navItems[0]);

  return (
    <>
    <Topheader/>
    <Navcivil/>
    <section>
                <div className="image-about">
                    {/* Background Image */}
                    <img src={img} alt="Contact Us" className="image-bg" />

                    {/* Overlay Content */}
                    <div className="overlay-about">
                        <h1 className="fade-in-text">Our Services</h1>
                    </div>
                </div>
            </section>
    <section>
    <div className="row text-center mb-30" style={{ marginTop:"20px"}}>
            <div className="col-sm-12">
              <div className="sec_hedding">
                <h3><span>All</span> Services</h3>
                <div className='underline-service'></div>
                <span className="b-line"></span>
              </div>
            </div>
          </div>
          </section>
    <section>
    <div className="container service-container">
      <div className="row">
       
        <div className="col-md-4 sidebar">
          <h4 className="sidebar-title">Our Services</h4>
          <ul className="nav-list service-list">
            {navItems.map((item) => (
              <li
                key={item.id}
                className={`nav-itemm ${selectedItem.id === item.id ? "active" : ""}`}
                onClick={() => setSelectedItem(item)}
              >
                <FontAwesomeIcon icon={item.icon} className="nav-iconn" />
                {item.title}
              </li>
            ))}
          </ul>
        </div>

       
        <div className="col-md-8 content-service">
          <h2 className="content-title-service">{selectedItem.title}</h2>
          <p className="content-description-service">{selectedItem.description}</p>
          <img src={selectedItem.image} alt={selectedItem.title} className="content-image-service" />

        </div>
      </div>
    </div>
    </section>
    <Footer/>
    </>
  );
};

export default Ourallservice;
